import { SortOption } from '@yes.technology/react-toolkit'

import { SortDirection } from 'shared/utils/array/sort'

export const SORT_DIRECTION_MAPS = {
  '': 'asc',
  asc: 'desc',
  desc: ''
} as const

export const getColumnSortInfo = (
  sortOptions: SortOption[],
  columnName: string
) => {
  const sortOption = sortOptions?.find((option) => !!option[columnName]) || {}
  const currentDirection = sortOption[columnName] || ''
  const sortOrderIndex =
    sortOptions?.findIndex((option) => !!option[columnName]) ?? -1
  const sortOrderNumber = sortOrderIndex >= 0 ? sortOrderIndex + 1 : null

  return {
    currentDirection,
    sortOrderNumber,
    shouldShowBadge: Boolean(
      sortOptions && sortOptions.length > 1 && sortOrderNumber
    )
  }
}

export const calculateNextSortDirection = (
  currentDirection: string
): string => {
  return (
    SORT_DIRECTION_MAPS[currentDirection as keyof typeof SORT_DIRECTION_MAPS] ||
    ''
  )
}

export const createSortOptions = (
  sortOptions: SortOption[],
  columnName: string,
  direction: string,
  isMultipleSort: boolean
): SortOption[] => {
  const newSortOption = { [columnName]: direction as SortDirection }

  if (isMultipleSort) {
    // If the column is already being sorted, update only its direction
    if (sortOptions?.some((option) => !!option[columnName])) {
      const updatedOptions = sortOptions.map((option) =>
        Object.keys(option)[0] === columnName ? newSortOption : option
      )
      // Remove columns with empty direction
      return updatedOptions.filter((option) => {
        const key = Object.keys(option)[0]
        return option[key] !== ''
      })
    }
    // If the column is not being sorted, add it to the end (only if direction is not empty)
    if (direction !== '') {
      return [...(sortOptions || []), newSortOption]
    }
    return sortOptions || []
  }

  // Simple sorting: replace all options
  return [newSortOption]
}
